/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum RateType {
    Tiered = 'TIERED',
    TieredBudget = 'TIERED_BUDGET',
    Seasonal = 'SEASONAL'
}

export function RateTypeFromJSON(json: any): RateType {
    return RateTypeFromJSONTyped(json, false);
}

export function RateTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateType {
    return json as RateType;
}

export function RateTypeToJSON(value?: RateType | null): any {
    return value as any;
}

